var React = require('react');

function SmallPlus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 5H7V1c0-.6-.4-1-1-1S5 .4 5 1v4H1c-.6 0-1 .4-1 1s.4 1 1 1h4v4c0 .6.4 1 1 1s1-.4 1-1V7h4c.6 0 1-.4 1-1s-.4-1-1-1z"}));
}

SmallPlus.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = SmallPlus;

SmallPlus.default = SmallPlus;
